// document.addEventListener('DOMContentLoaded', function () {
//   const button = document.getElementById('show-job-info');
//   const jobDetails = document.getElementById('job-details');

//   button.addEventListener('click', function () {
//     if (jobDetails.style.display === 'none') {
//       jobDetails.style.display = 'block';
//       button.textContent = 'Hide Job Details';
//     } else {
//       jobDetails.style.display = 'none';
//       button.textContent = 'Show Job Details';
//     }
//   });
// });


// <link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.css">
// <link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick-theme.min.css">

// <script src="https://code.jquery.com/jquery-3.6.0.min.js"></script>
// <script type="text/javascript" src="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.js"></script>

// <script>
//   $(document).ready(function(){
//     $('.job_list').slick({
//       slidesToShow: 4,
//       slidesToScroll: 1,
//       arrows: true,
//       autoplay: false,
//       autoplaySpeed: 3000,
//       responsive: [
//         {
//           breakpoint: 1024,
//           settings: {
//             slidesToShow: 2,
//             slidesToScroll: 1,
//           }
//         },
//         {
//           breakpoint: 768,
//           settings: {
//             slidesToShow: 2,
//             slidesToScroll: 1,
//           }
//         },
//         {
//           breakpoint: 480,
//           settings: {
//             slidesToShow: 3,
//             slidesToScroll: 1,
//           }
//         }
//       ]
//     });
//   });
// </script>


document.addEventListener('DOMContentLoaded', function () {
   // $(document).ready(function(){
   //  $('.jt').slick({
   //    slidesToShow: 4,
   //    slidesToScroll: 1,
   //    arrows: true,
   //    autoplay: true,
   //    autoplaySpeed: 3000,
   //    responsive: [
   //      {
   //        breakpoint: 1024,
   //        settings: {
   //          slidesToShow: 2,
   //          slidesToScroll: 1,
   //        }
   //      },
   //      {
   //        breakpoint: 768,
   //        settings: {
   //          slidesToShow: 2,
   //          slidesToScroll: 1,
   //        }
   //      },
   //      {
   //        breakpoint: 480,
   //        settings: {
   //          slidesToShow: 3,
   //          slidesToScroll: 1,
   //        }
   //      }
   //    ]
   //  });

  // Select all buttons and popups
  const buttons = document.querySelectorAll('.btn[data-job]');
  const popups = document.querySelectorAll('.popup');
  const closeButtons = document.querySelectorAll('.close[data-close]');

  // Function to open a popup
  buttons.forEach(button => {
    button.addEventListener('click', function () {
      const jobId = button.getAttribute('data-job');
      const popup = document.getElementById(jobId);
      if (popup) {
        popup.style.display = 'flex'; // Show the popup
      }
    });
  });

  // Function to close a popup
  closeButtons.forEach(close => {
    close.addEventListener('click', function () {
      const jobId = close.getAttribute('data-close');
      const popup = document.getElementById(jobId);
      if (popup) {
        popup.style.display = 'none'; // Hide the popup
      }
    });
  });

  // Close popup when clicking outside of it
  popups.forEach(popup => {
    popup.addEventListener('click', function (event) {
      if (event.target === popup) {
        popup.style.display = 'none';
      }
    });
  });
});


